// extracted by mini-css-extract-plugin
export default {"searchBox":"search_searchBox__Xwnvh","searchContainer":"search_searchContainer__9+ZLA","searchList":"search_searchList__WCJue"};